import { useId } from 'react'
import { Separator } from '@mc/design-system'
import Link from 'components/Link'
import { ArticleItem } from 'types/data'
import { trackArticleClicked } from '../events'
import { AsideListItem } from './AsideListItem'

interface AsideListProps {
  items: Array<ArticleItem>
  title: string
}

const AsideList = ({ title, items }: AsideListProps) => {
  const headingId = useId()
  return (
    <aside className='d-none d-md-block' aria-labelledby={headingId}>
      <h2 id={headingId} className='mc-text-h8 mc-text--uppercase mc-mb-2'>
        {title}
      </h2>
      {items?.map((item) => (
        <div key={item.title}>
          <Separator className='mc-my-3' />
          <Link
            className='d-flex justify-content-between align-items-md-center'
            href={item.linkPath}
            onClick={() => trackArticleClicked(item)}
            passHref
          >
            <AsideListItem item={item} />
          </Link>
        </div>
      ))}
    </aside>
  )
}

export default AsideList
